import Box from '@mui/material/Box';
import MuiModal from '@mui/material/Modal';
import { FC, PropsWithChildren } from 'react';

interface ModalProps {
  open: boolean;
  handleClose: () => void;
}
const Modal: FC<PropsWithChildren<ModalProps>> = ({ children, open, handleClose }) => (
  <div>
    <MuiModal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        {children}
      </Box>
    </MuiModal>
  </div>
);

export default Modal;
